export default __webpack_public_path__ + "static/media/mobilecase.52bd44a7.jpg";